'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var atom_model = require('./atom.model.js');
var condition_model = require('./condition.model.js');
var expression_model = require('./expression.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseFactory = /*#__PURE__*/_createClass__default["default"](function BaseFactory() {
  _classCallCheck__default["default"](this, BaseFactory);
});

/**
 * Class for atom factory.
 *
 * @export
 * @class AtomFactory
 * @extends {BaseFactory}
 */
var AtomFactory = /*#__PURE__*/function (_BaseFactory) {
  function AtomFactory() {
    _classCallCheck__default["default"](this, AtomFactory);
    return _callSuper(this, AtomFactory, arguments);
  }
  _inherits__default["default"](AtomFactory, _BaseFactory);
  return _createClass__default["default"](AtomFactory, [{
    key: "getAtom",
    value: function getAtom(a, value, valueType) {
      return new a(value, valueType);
    }
  }]);
}(BaseFactory);

/**
 * Class for expression factory.
 *
 * @export
 * @class ExpressionFactory
 * @extends {BaseFactory}
 */
var ExpressionFactory = /*#__PURE__*/function (_BaseFactory2) {
  function ExpressionFactory() {
    _classCallCheck__default["default"](this, ExpressionFactory);
    return _callSuper(this, ExpressionFactory, arguments);
  }
  _inherits__default["default"](ExpressionFactory, _BaseFactory2);
  return _createClass__default["default"](ExpressionFactory, [{
    key: "getExpression",
    value: function getExpression(e, operands, operator) {
      return new e(operands, operator);
    }
  }]);
}(BaseFactory);

/**
 * Class for condition factory.
 *
 * @export
 * @class ConditionFactory
 * @extends {BaseFactory}
 */
var ConditionFactory = /*#__PURE__*/function (_BaseFactory3) {
  function ConditionFactory() {
    _classCallCheck__default["default"](this, ConditionFactory);
    return _callSuper(this, ConditionFactory, arguments);
  }
  _inherits__default["default"](ConditionFactory, _BaseFactory3);
  return _createClass__default["default"](ConditionFactory, [{
    key: "getCondition",
    value: function getCondition(c, operands, operator) {
      return new c(operands, operator);
    }
  }]);
}(BaseFactory);
var atomDict = {
  IntConstant: atom_model.IntConstant,
  RealConstant: atom_model.RealConstant,
  StringConstant: atom_model.StringConstant,
  BoolConstant: atom_model.BoolConstant,
  DatetimeConstant: atom_model.DatetimeConstant,
  IntParam: atom_model.IntParam,
  RealParam: atom_model.RealParam,
  StringParam: atom_model.StringParam,
  DatetimeParam: atom_model.DatetimeParam,
  BoolParam: atom_model.BoolParam,
  IntAccum: atom_model.IntAccum,
  RealAccum: atom_model.RealAccum,
  StringAccum: atom_model.StringAccum,
  BoolAccum: atom_model.BoolAccum,
  AttrVariable: atom_model.AttrVariable,
  AttrVariableWithAlias: atom_model.AttrVariableWithAlias,
  LoadingVariable: atom_model.LoadingVariable,
  AliasReference: atom_model.AliasReference
};
var exprDict = {
  NullExpression: expression_model.NullExpression,
  FunctionExpression: expression_model.FunctionExpression,
  ArithmeticExpression: expression_model.ArithmeticExpression,
  ArithmeticExpressionInWhereClause: expression_model.ArithmeticExpressionInWhereClause,
  ArithmeticExpressionInAggregationFunction: expression_model.ArithmeticExpressionInAggregationFunction
};
var condDict = {
  NullCondition: condition_model.NullCondition,
  ComparisonCondition: condition_model.ComparisonCondition,
  IsCondition: condition_model.IsCondition,
  InCondition: condition_model.InCondition,
  BetweenAndCondition: condition_model.BetweenAndCondition,
  NotCondition: condition_model.NotCondition,
  AndCondition: condition_model.AndCondition,
  OrCondition: condition_model.OrCondition
};
exports.FactoryProducer = void 0;
(function (_FactoryProducer) {
  var factories = new _Map__default["default"]([[AtomFactory, new AtomFactory()], [ConditionFactory, new ConditionFactory()], [ExpressionFactory, new ExpressionFactory()]]);

  /**
   * Retrieve a factory from its class name.
   *
   * @export
   * @template F
   * @param {new () => F} f
   * @returns {F}
   */
  function getFactory(f) {
    return factories.get(f);
  }
  _FactoryProducer.getFactory = getFactory;
})(exports.FactoryProducer || (exports.FactoryProducer = {}));

exports.AtomFactory = AtomFactory;
exports.BaseFactory = BaseFactory;
exports.ConditionFactory = ConditionFactory;
exports.ExpressionFactory = ExpressionFactory;
exports.atomDict = atomDict;
exports.condDict = condDict;
exports.exprDict = exprDict;
